import React from 'react'
import { createProjectunit } from '../../store/actions/index';
import ProjectunitModal from './ProjectunitModal';

const CreateProjectunitModal = (props) => {

  const onSubmitAction = (values) => {
    values['project_id'] = props.formObject.project_id;
    return createProjectunit(values)
  };

  const modalTitle = "Bauabschnitt anlegen";

  const initialValues = { title: '',
      description: '',
    };

  return (
    <ProjectunitModal
      modalTitle={modalTitle}
      onSubmitAction={onSubmitAction}
      initialValues={initialValues}
    />
  )
}

export default CreateProjectunitModal



// WEBPACK FOOTER //
// ./src/components/Modals/CreateProjectunitModal.js